import React from "react";
import styles from './styles.module.scss';
import Slider from "react-slick";

function PrevArrow(props: any) {
  const { className, style, onClick } = props;
  return (
    <div className={`${styles.prev}`} style={style} onClick={onClick}>
      <svg xmlns="http://www.w3.org/2000/svg" fill="none" width="7.5" height="13.5">
        <path d="M7.28 1.28q.106-.105.163-.243Q7.5.899 7.5.75q0-.074-.014-.146Q7.47.53 7.443.463q-.028-.068-.07-.13Q7.334.272 7.28.22 7.228.167 7.167.126q-.062-.04-.13-.069-.068-.028-.14-.043Q6.823 0 6.75 0q-.15 0-.287.057-.138.057-.243.163L-.31 6.75l6.53 6.53q.105.106.243.163.138.057.287.057.074 0 .146-.014.073-.015.141-.043.068-.028.13-.07.061-.04.113-.093.053-.052.094-.113.04-.062.069-.13.028-.068.043-.14.014-.073.014-.147 0-.15-.057-.287-.057-.138-.163-.243L1.81 6.75l5.47-5.47Z" fillRule="evenodd" fill="#15181D"/>
      </svg>
    </div>
  );
}

function NextArrow(props: any) {
  const { className, style, onClick } = props;
  return (
    <div className={`${styles.next}`} style={style} onClick={onClick}>
      <svg xmlns="http://www.w3.org/2000/svg" fill="none" width="7.5" height="13.5">
        <path d="M.22 1.28q-.106-.105-.163-.243Q0 .899 0 .75 0 .676.014.604.03.53.057.463q.028-.068.07-.13Q.166.272.22.22.272.167.333.126q.062-.04.13-.069Q.531.03.603.014.677 0 .75 0q.15 0 .287.057.138.057.243.163l6.53 6.53-6.53 6.53q-.105.106-.243.163-.138.057-.287.057-.074 0-.146-.014-.073-.015-.141-.043-.068-.028-.13-.07-.061-.04-.113-.093-.053-.052-.094-.113-.04-.062-.069-.13-.028-.068-.043-.14Q0 12.823 0 12.75q0-.15.057-.287.057-.138.163-.243l5.47-5.47L.22 1.28Z" fillRule="evenodd" fill="#15181D"/>
      </svg>
    </div>
  );
}

export default function Benchmark() {

  return <section className={styles.benchmark}>
    <h2>部分客户</h2>
    <Slider infinite autoplay speed={1000} arrows dots={false} prevArrow={<PrevArrow />} nextArrow={<NextArrow />}>
      <div className={styles.benchmark1}><img src="./static-official/images/clients20251103.png" alt="部分客户1" /> </div>
      <div className={styles.benchmark1}><img src="./static-official/images/brenchmark-2.png" alt="部分客户2" /> </div>
    </Slider>
  </section>
}
